import api from 'api';

export function getRefundsList(params) {
  const statuses = params.refundStatuses;
  const apiParams = {
    identifierId: params.identifierId,
    orderDisplayId: params.orderDisplayId,
    customerId: params.customerId,
    caseId: params.caseId,
    ticketId: params.ticketId,
    refundStatuses: Array.isArray(statuses) ? statuses.join(',') : statuses,
    refundType: params.refundType,
    orderType: params.orderType,
    // This list is a WHITELIST, not a pass-through — a filter missing from it is dropped
    // silently, so the dropdown works, the URL updates, and the results never change.
    // Anything added to FILTER_KEYS in RefundManagement.jsx has to be added here too.
    collectionMode: params.collectionMode,
    startDate: params.startDate,
    endDate: params.endDate,
    page: params.page || 1,
    limit: params.limit || 10,
  };

  const cleanParams = Object.fromEntries(
    Object.entries(apiParams).filter(([_, v]) => v != null && v !== '')
  );

  return api.get(`/order/refund/list`, { params: cleanParams });
}

export function submitPMApproval(payload) {
  return api.post(`/order/layer1/approval`, payload);
}

export function submitFinanceApproval(payload) {
  return api.post(`/order/layer2/approval`, payload);
}

export function submitProcessed(payload) {
  return api.post(`/order/refund/processed`, payload);
}

/**
 * Re-reads one COD payout's live status from Easebuzz and applies it, so finance does not have
 * to wait for the 6-hourly reconcile. Same code path that job runs, just for a single refund.
 *
 * Gated to the finance allowlist in internal-api-server, which 403s anyone else.
 */
export function syncPayoutStatus(refundId) {
  return api.post(`/order/refund/payout/sync`, { refundId });
}

/**
 * Re-sends an EXISTING payout link to the customer over WhatsApp. It never creates a link —
 * a fresh link would be a second claimable payout against the same money.
 *
 * Server-side it first runs the same live status check as syncPayoutStatus above, so a link
 * that has since been claimed or died is refused (and the refund row corrected) rather than
 * sending the customer somewhere that fails.
 *
 * Open to any authenticated caller — coaches included. There is no role gate: a resend mints
 * nothing, moves no money and returns no URL, so the only refusals are the live-status ones
 * above (link already claimed, or dead), which also correct the refund row as a side effect.
 */
export function resendPayoutLink(refundId) {
  return api.post(`/order/refund/resend-payout-link`, { refundId });
}

export function getSubscriptionRefundDetails(id) {
  return api.get(`/offline/subscriptionTransaction/details/${id}`);
}

export function initiateOfflineRefund(payload) {
  return api.post(`/offline/refund/initiate`, payload);
}

export function downloadRefundsList(params) {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v != null && v !== '')
  );
  return api.get(`/order/refund/list/download`, { params: cleanParams });
}

export function getTicketDetails(ticketId) {
  return api.get(`/get-ticket-details/${ticketId}`);
}
